<template>
  <div class="file-upload">
    <input type="file"
           :multiple="multiple"
           ref="input" hidden
           :accept="acceptedTypes"
           @change="filesChange($event.target.files)">
    <div v-if="!value.length"
         class="inline-flex items-center text-sm text-text-label
                hover:text-red transition duration-200 cursor-pointer"
         @click="$refs.input.click()">
      <IconAttach class="mr-4"/>
      {{ $t('attachFiles') }}
    </div>
    <div v-else class="space-y-4 max-w-full">
      <div v-for="(file,i) in value" :key="i"
           class="flex items-center text-sm text-text-label">
        <IconFile class="flex-none w-8 h-8 mr-4"/>
        <div class="max-w-xs lg:max-w-sm truncate">{{ file.name }}</div>
        <IconCross class="flex-none w-3 ml-4 hover:text-red cursor-pointer" @click.native="removeFile(i)"/>
      </div>
    </div>
    <slot name="errors"></slot>
  </div>
</template>

<script>
import IconAttach from "@/components/icons/IconAttach";
import IconFile from "@/components/icons/IconFile";
import IconCross from "@/components/icons/IconCross";

export default {
  name: "FileUpload",
  components: {IconCross, IconFile, IconAttach},
  props: {
    value: {
      type: Array,
      required: true
    },
    accept: {
      type: [String, Array],
      default: '*'
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    acceptedTypes() {
      if (Array.isArray(this.accept)) {
        return this.accept.map(item => `.${item}`).join(',')
      } else {
        return this.accept
      }
    },
  },
  methods: {
    filesChange(fileList) {
      if (!fileList.length) return;
      this.$emit('input', Array.from(fileList))
    },
    removeFile(index) {
      let fileBuffer = this.value;
      fileBuffer.splice(index, 1)
      if (fileBuffer.length) {
        this.$emit('input', fileBuffer)
      } else {
        this.$emit('input', [])
        this.$refs.input.value = null;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        attachFiles: 'Attach the file'
      },
      ru: {
        attachFiles: 'Прикрепить файл'
      }
    }
  }
}
</script>

<style lang="scss">
.file-upload {
  @apply flex relative;
  &.--error {
    @apply text-red;
    div {
      color: #e04067 !important;
    }
  }

  .error {
    @apply block text-red text-xs absolute bottom-0 transform translate-y-full;
  }
}
</style>